module.exports = __webpack_public_path__ + "src/assets/img/index_tuijian_3.80d74919.png";